"use client";

import { redirect } from "next/navigation";

import { useFilterSheetContext } from "@/components/sheets/FilterSheet/context";
import { filterSheetHeadingClassName } from "@/components/sheets/FilterSheet/filter-sheet-glass";
import { cn } from "@/lib/utils";

type Props = {
	queryKey: string;
	keywords: string[];
	defaultKey: string;
};

export default function FilterKeywordsSection({ keywords, queryKey, defaultKey }: Props) {
	const { pathname, mutSearchParams, setSearchParam } = useFilterSheetContext();
	const current = mutSearchParams.get(queryKey) ?? undefined;

	if (current !== undefined && !keywords.includes(current)) redirect(pathname);

	const selectedValue = current ?? defaultKey;

	return (
		<div className="flex flex-col gap-2">
			<h3 className={filterSheetHeadingClassName}>Keywords</h3>
			<div
				className="z-10 flex h-5 max-w-full gap-1.5 overflow-x-auto pb-1 xs:h-6 xs:gap-2 sm:h-7 md:h-6 md:gap-1.5"
				style={{ scrollbarWidth: "none" }}
			>
				{keywords.map((value) => (
					<button
						key={value}
						type="button"
						aria-label={`Filter by ${value}`}
						onClick={() => setSearchParam(queryKey, value)}
						className={cn(
							"flex min-h-[22px] min-w-[22px] items-center justify-center text-nowrap rounded-full border-solid border-[0.5px] border-[color:var(--color-border-standard)] bg-transparent px-3 text-[10px] text-white transition-colors duration-300 hover:border-[color:var(--color-border-visible)] hover:bg-white/10 xs:px-3.5 xs:text-[11px] sm:px-6 sm:text-xsm2 md:px-4 md:text-xs dark:border-[color:var(--glass-border)]",
							selectedValue === value && "border-[color:var(--color-border-visible)] bg-white/15"
						)}
					>
						{value}
					</button>
				))}
			</div>
		</div>
	);
}
